// @flow
import * as React from 'react';

import { Base } from '@gandi/ui';

import { DiscountPrice } from 'src/shared/DiscountPrice';
import { RenewPrice } from 'src/shared/RenewPrice';

import PriceText from './PriceText';

import styles from './AvailabilityPrice.scss';

export type Props = {
  currency: string,
  fqdn: string,
  hasDiscount: boolean,
  minDuration: number,
  needsPhaseSelection: boolean,
  normalPrice: number,
  price: number,
  priceDiff: number,
  renewMinDuration: number,
  renewPrice: number,
};

export function AvailabilityPrice({
  currency,
  hasDiscount,
  fqdn,
  minDuration,
  needsPhaseSelection,
  normalPrice,
  price,
  priceDiff,
  renewMinDuration,
  renewPrice,
}: Props): React.MixedElement {
  if (hasDiscount) {
    return (
      <DiscountPrice
        currency={currency}
        minDuration={minDuration}
        normalPrice={normalPrice}
        price={price}
      >
        <RenewPrice fqdn={fqdn} />
      </DiscountPrice>
    );
  }
  return (
    <Base className={styles.cellGrid}>
      <PriceText
        currency={currency}
        price={price}
        minDuration={minDuration}
        renewPrice={renewPrice}
        renewMinDuration={renewMinDuration}
        priceDiff={priceDiff}
        needsPhaseSelection={needsPhaseSelection}
      />
    </Base>
  );
}
